var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'notification-program-calendar',
    {
      isMouseOverNotification: _vm.isMouseOverNotification,
      'with-nav-banner': _vm.showAlertBanner,
    } ]},[_c('h5',[_vm._v(_vm._s(_vm.isAddingDish ? 'Add' : 'Copy')+" contents to which "+_vm._s(_vm.isDuplicatingDay ? 'day' : 'week')+"?")]),_c('p',[_vm._v("Select the "+_vm._s(_vm.isDuplicatingDay ? 'day' : 'week')+" you want the contents to appear on.")]),_c('a',{staticClass:"link blue",on:{"click":_vm.cancelDuplication}},[_vm._v(" Cancel "),(!_vm.isAddingDish)?_c('span',[_vm._v("Duplication")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }